export const MapTableStyles = ` 
    /* CSS styles for Inspection overview */
    .p-datatable  ,
    .p-component
    {
      font-size: 12px !important;
    }
  /* CSS styles for Inspection overview */ 
`;

export default {
    MapTableStyles,
};
